/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CheckInAliases {
  CARD_CONTAINER_BODY_CHECK_IN = 'card-container-body-check-in',
  CARD_CONTAINER_CHECK_IN = 'card-container-check-in',
  CARD_CONTAINER_SEPARATOR_CHECK_IN = 'card-container-separator-check-in',
  CARD_CONTAINER_ZONE_QRCODE_CHECK_IN = 'card-container-zone-qrcode-check-in',
  CARD_CONTAINER_ZONE_TEXT_CHECK_IN = 'card-container-zone-text-check-in',
  CONTEXTUAL_BAR_CHECK_IN = 'contextual-bar-check-in',
  FIELD_CHECK_IN_MESSAGE = 'field-check-in-message',
  PANEL_INTERNAL_CHECK_IN = 'panel-internal-check-in',
  QR_CODE_CHECK_IN = 'qr-code-check-in',
  TEXT_CHECK_IN_MESSAGE = 'text-check-in-message',
}
export { CheckInAliases };
